import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { FormatWriteSettingsAdapter, formatWriteSettingsAdapts } from './format-write-settings.adapter';
import { IcebergFormatWriteSettings } from 'app/model/pipeline/copysink/format-write-settings/iceberg-format-write-settings';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(IcebergFormatWriteSettings),
    asynchronous: true,
    adapts: {
        ...formatWriteSettingsAdapts
    }
})
export class IcebergFormatWriteSettingsAdapter extends FormatWriteSettingsAdapter<
    IcebergFormatWriteSettings,
    Model.IcebergFormatWriteSettings
> {
    protected override async _toResource(model: IcebergFormatWriteSettings): Promise<Model.FormatWriteSettings> {
        const result: Model.IcebergFormatWriteSettings = FormatWriteSettingsAdapter.getCommonWriteSettingsProperties(
            Metamodel.modelFor(IcebergFormatWriteSettings).name
        );
        FormatWriteSettingsAdapter.toFormatWriteSettingsResource(model, result);
        return result;
    }

    protected override async _toModel(
        resource: Model.IcebergFormatWriteSettings,
        copySink: CopySink
    ): Promise<IcebergFormatWriteSettings> {
        const result = FormatWriteSettingsAdapter.createWriteSettingsWithCommonProperties(
            IcebergFormatWriteSettings.MODEL,
            copySink
        ) as IcebergFormatWriteSettings;
        FormatWriteSettingsAdapter.toFormatWriteSettingsModel(resource, result);
        return result;
    }
}
